<template>
	<div v-show="mode.isActive && mode.showOriginal" id="original_opacity_container" class="orto-no-intraoral" onmousedown="preventHide(event);">
		<span class="opacity-span opacity-title-span">OPACITY</span>
		<span class="opacity-span">100</span>
		<div id="original_opacity" class="opacity-slider"></div>
		<span class="opacity-span">0</span>
	</div>
</template>

<script>
export default {
	name: "OriginalTeethOpacity",
	props: ["mode"],
	mounted() {
		console.log("OriginalTeethOpacity mounted");
		$("#original_opacity").slider({
			orientation: "vertical",
			min: 0,
			max: 1,
			step: 0.01,
			value: original_teeth_opacity,
			slide: function (event, ui) {
				originalTeethOpacityChanged(ui.value);
			},
		});
	},
	methods: {
	}
}

function originalTeethOpacityChanged(value) {
	original_teeth_opacity = value;
	vueApp.allItems.forEach((item) => {
		if (item.defaultMeshId) {
			var vmesh = viewer.scene.getObjectById(item.defaultMeshId, true);
			if (vmesh && vmesh.isVisible) {
				vmesh.material.opacity = original_teeth_opacity;
			}
		}
	});
}
</script>

<style scoped>
@import "../opacity/opacity.css";

#original_opacity_container {
	position: absolute;
	text-align: center;
	z-index: 9;
	width: 35px;
	left: 15px;
	top: 90px;
	height: calc(100% - 220px);
}

.opacity-title-span {
	margin-left: -11px;
}
</style>